/**
 * Generates an array of numeric values formatted as strings with leading zeros.
 * @param {number} lowerBound - The lower boundary of the time range.
 * @param {number} upperBound - The upper boundary of the time range.
 * @param {number} [step=1] - The increment between consecutive time values (defaulted to 1 if not provided).
 * @returns {Array<string>} An array containing values within the specified range, formatted as strings with leading zeros.
 */
export function rangeArray(lowerBound: number, upperBound: number, step = 1): Array<string> {
    if (lowerBound > upperBound) {
        return [];
    }

    return Array.from({ length: Math.ceil((upperBound - lowerBound + 1) / step) }, (_, index) => {
        const value = index * step + lowerBound;
        return value.toString().padStart(2, '0');
    });
}
